import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";

class PromoSlider extends Component {
	render() {
		const { slides, size, secondarySlider } = this.props;
		return (
			<React.Fragment>
				<div
				style={{"marginBottom":"0%","width":"93vw","marginTop":"0px"}}
					className={
						secondarySlider
							? "slider-wrapper secondary-slider-wrapper my-20"
							: "slider-wrapper bg-light pt-5 "
					}
				>
					{slides.length > 0 && slides.map((slide) =>
							slide.data.model === "3" ? (
								<a
									href={slide.url}
									className="slider-wrapper__img-wrapper"
									key={slide.data.id}
									style={{ position: "relative" }}
								>
									{/* if customURL then use anchor tag */}
									<LazyLoad>
										<img
											src={localStorage.getItem('cdn')+slide.data.image}
											alt={slide.data.name}
											className={`slider-wrapper__img slider-cust-img ${!secondarySlider &&
												"slider-wrapper__img-shadow"} custom-promo-img`}
											style={{
												height: '10vw',
												width: '10vw',
											}}
										/>
									</LazyLoad>
									<Ink duration="500" hasTouch={true} />
								</a>
							) : (
								<NavLink
									to={"../" + slide.url}
									className="slider-wrapper__img-wrapper"
									key={slide.data.id}
									style={{ position: "relative" }}
								>
									<LazyLoad>
										<img
											src={localStorage.getItem('cdn')+slide.data.image}
											alt={slide.data.name}
											className={`slider-wrapper__img slider-cust-img ${!secondarySlider &&
												"slider-wrapper__img-shadow"} custom-promo-img`}
												style={{
													height: '62vw',
													width: 'auto',
												}}
										/>
									</LazyLoad>
									<Ink duration="500" hasTouch={true} />
								</NavLink>
							)
						)
					}
				</div>
			</React.Fragment>
		);
	}
}

export default PromoSlider;
